import { QAMetricState } from '../types'
import QAMetric from 'models/manufacturing/qaMetric';
import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import ProblemDetails from 'models/problemDetails'

const state: QAMetricState = {
    list: [],
    timestampMS: null
}

const getters: GetterTree<QAMetricState, any> = {
    getMetricList: state => () => {
        return state.list;
    }
}

const mutations: MutationTree<QAMetricState> = {
    setMetricList(state, data) {
        //reset list first.
        state.list = [];
        data.forEach((metric: QAMetric, index) => {
            Vue.set(state.list, index, metric);
        });
    },
    setMetricTimestamp(state) {
        // 24 hours
        const expiration = 24 * 60 * 60 * 1000;
        state.timestampMS = new Date().getTime() + expiration;
    }
}

const actions: ActionTree<QAMetricState, any> = {
    async fetchMetrics({ commit, state, dispatch }) {
        if (state.list.length == 0 || (state.timestampMS && new Date().getTime() > state.timestampMS)) {
            await dispatch('refreshMetrics');
        }
    },
    async refreshMetrics({ commit, state }) {
        const url = Vue.IdentityConfig.manufacturingApiUri + "/qametrics";
        const options: RequestInit = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        await fetch(url, options)
            .then(response => {
                if (!response.ok)
                    throw response;
                return response.json() as Promise<Array<QAMetric>>
            })
            .then(data => {
                    commit('setMetricList', data);
                    commit('setMetricTimestamp');
            })
            .catch(error => {
                if (error instanceof Response) {
                    error.json().then((data: ProblemDetails) => {
                        ProblemDetails.ErrorMessages(data).forEach(e => {
                            Vue.Logger.LogError(e);
                        })
                    })
                } else {
                    Vue.Logger.LogError(error);
                }
            });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}